<template>
    <div>
        <div style="height: 30px;" ref="notice_div">
            <marquee behavior="scroll" class="main-marquee" >
                <div style="float:left;width:40%;" v-for="(notice, key) in notice" :key="key">
                    <a :href="notice.id">
                        {{notice.title}}
                    </a>
                </div>
            </marquee>
        </div>
        <van-swipe class="banner" :autoplay="5000" indicator-color="white" :width="'100%'" style="margin-top: 15px;">
            <van-swipe-item v-for="(banner, key) in banner"  :key="key" class="item">
                <van-image  fit="cover" class="image" @click="bannerImgUrl(banner.id,banner.is_url,banner.url)" :src="banner.cover_url_src" style="height:200px"/>
            </van-swipe-item>
            <van-swipe-item v-if="banner.length <= 0 && isBannerInited">
                <van-image  fit="cover" class="image" :src="require('../assets/images/banner/340b03b0623ac6995ee103554ba9b5e.png')" style="height:200px"/>
            </van-swipe-item>
			<van-swipe-item v-if="!isBannerInited">
                <div class="image loading-banner" style="height:200px">
					<van-loading size="48" color="#acacac" type="spinner" />
				</div>
            </van-swipe-item>
        </van-swipe>
        <div class="base-flex-center" style="padding:0.5rem 0;">
            <van-grid class="index-options-container" :column-num="4" style="padding: 0; box-sizing: border-box;">
                <van-grid-item v-for="(navigationItem, navigationIndex) in navigationData" :key="navigationIndex" :to="{ name : navigationItem.link }">
                    <svg class="icon" aria-hidden="true">
                        <use :xlink:href="navigationItem.icon"></use>
                    </svg>
                    <!-- <div style="margin-top: 10px; font-size: 0.35rem;">{{navigationItem.text}}</div> -->
                    <div style="margin-top: 10px; font-size: 0.30rem;">{{navigationItem.text}}</div>
                </van-grid-item>
            </van-grid>
            <div class="index-container" style="padding: 0 0 10px 0;width: 100vw;" v-if="activityList.length > 0">
                <div class="index-title" style="padding: 20px 20px 10px 20px;">优惠活动</div>
                <van-empty v-if="activityList.length <= 0" description="暂无活动" />
                <van-list v-else>
                    <van-cell v-for="(activityItem, activityIndex) in activityList" :key="activityIndex" @click="$router.push({name : 'ActivityDetail', query : { id : activityItem.id }})">
                        <van-row>
                            <van-col :span="18" style="font-size: 16px;">{{activityItem.name}}</van-col>
                            <van-col :span="6" style="text-align: right;">
                                <van-tag type="primary">{{$store.state.systemEnum['company']['activity']['type'][activityItem.type]}}</van-tag>
                            </van-col>
                            <van-col :span="24" style="font-size: 12px; padding: 5px 0 0 0; color: #888888;">
                                活动时间：{{activityItem.start_time}} ~ {{activityItem.end_time}}
                            </van-col>
                        </van-row>
                    </van-cell>
                </van-list>
            </div>
            <div class="index-container" style="padding: 5vw;width: 90vw;">
                <van-row>
                    <van-col :span="16" class="index-title">积分商城</van-col>
                    <van-col :span="8" class="index-more">
                        <span @click="$router.push({ name : 'IntegralGoods' })">更多>></span>
                    </van-col>
                </van-row>
                <van-grid v-if="integralGoodsList.length > 0" class="integral-goods-list" :column-num="2" :gutter="15" border style="padding-left: 0;">
                    <van-grid-item class="integral-goods-item" v-for="(item, index) in integralGoodsList" :key="index" @click="$router.push({ name:'IntegralGoodsDetail', query : { id : item.id } })">
                        <van-image :src="item.images_info[0]['url']" />
                        <div class="integral-goods-title">{{item.title}}</div>
                        <div class="integral-goods-integral">
							<div class="goods-inline" v-if="item.integral > 0">{{item.integral}}<span>积分</span></div>
							<div class="goods-inline" v-if="item.integral > 0 && item.amount > 0">+</div>
							<div class="goods-inline" v-if="item.amount > 0">{{item.amount}}<span>元</span></div>
                        </div>
                    </van-grid-item>
                </van-grid>
                <van-empty v-else description="暂无数据" />
            </div>
        </div>
    </div>
</template>

<script>
    import api from "../assets/js/api";

    export default {
        name: "Index",
        data(){
            return {
                timer:null,
                integralGoodsList : [],
                banner : [],
                notice : [],
                activityList : [],
                navigationData : [
                    {
                        text: '一键加油',
                        icon: '#icon-youkachongzhi',
                        link: 'Oiling',
                    },
                    {
                        text: '一键办卡',
                        icon: '#icon-shenqingbanka',
                        link: 'CardHandle'
                    },
                    {
                        text: '充值油卡',
                        icon: '#icon-kapianjihuo',
                        link: 'Recharge'
                    },
                    {
                        text: '附近油站',
                        icon: '#icon-dizhiguanli',
                        link: 'SiteIndex'
                    },
                    {
                        text: '邀请有礼',
                        icon: '#icon-liwu02-g',
                        link: 'InviteCode',
                    },
                    {
                        text: '个人中心',
                        icon: '#icon-yonghu',
                        link: 'User'
                    },
                    {
                        text: '优惠券',
                        icon: '#icon-youhuiquanindex',
                        link: 'CouponIndex'
                    },
                    {
                        text: '抽奖',
                        icon: '#icon-zhuanpan',
                        link: 'LotteryChance'
                    }
                ],
				isBannerInited: false
            };
        },
        created() {
            let self = this;
            api.request('/integral_goods/list', {
                page : 1,
                page_size : 6,
            }).then(res => {
                self.integralGoodsList = res.data.data;
            });
            api.request('/activity/list').then(res => {
                self.activityList = res.data;
            });
            api.request('/banner/list').then(res => {
                self.banner = res.data;
				self.isBannerInited = true;
            });
            api.request('/notice/list').then(res => {
                if(res.data.length == 0){
                    self.$refs.notice_div.style="display:none";
                }else{
                    for(let i=0; i<res.data.length; i++){
                        res.data[i]['id'] = './notice?id='+res.data[i]['id'];
                    }
                    self.notice = res.data;
                }
            });
        },
        methods: {
            bannerImgUrl(id,is_url,url){
                if(is_url){
                    window.location.href = url;
                }else{
                    this.$router.push({path:'./banner?id='+id})
                }
            }
        },
		computed : {
			goodsList() {
				return this.integralGoodsList
			}
		}
    }
</script>

<style lang="scss" scoped>
    @import '../style/base.scss';
    @import '../style/themeify.scss';
    *{
        @include themeify{
            .main-marquee{
                line-height: 30px;
                color: themed('colorText')
            }
        }
    }

    .base-flex-center {
        flex-direction: column;
    }

	.goods-inline {
		display: inline;
	}

    .banner{
        margin: auto;
        width: 90%;
        border-radius: 0.6rem;

		.image{
			display: block;
		}

		.loading-banner {
			background: #dedede;
			display: flex;
			justify-content: center;
			align-items: center;
		}

    }

    .index-options-container{
        background: #ffffff;
        padding: 0 12px;
    }

    .index-container{
        background-color: #ffffff;
        margin-top: 20px;
        padding: 20px;

        .index-title{
            font-size: 18px;
        }

        .index-more{
            text-align: right;

            &:active{
                text-decoration: underline;
            }
        }
    }
    .icon{
        font-size: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue